import { csvToObj } from 'csv-to-js-parser';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { getGeocodePositionFromText } from '@/domain/position-geocode/utils/search-geocode/get-geocode-position-from-text/get-geocode-position-from-text';
import { TourEventType } from '@/domain/project-tour-ontour/entities/project-tour-ontour-event.entity';
import {
  defaultTourEventFormValues,
  TourEventsFormValues,
} from '@/ui/pages/app/project/tour/ontour/travels-and-dates/components/tour-event-form-values/TourEventsFormValues';

// needed to parse in format like 19/10/2024
dayjs.extend(customParseFormat);

type CsvColumns = {
  Date: string;
  Nom: string;
  Lieu: string;
  Fréquentation: string;
  Type: string;
};

export async function convertCsvToTourEventsFormValues(
  text: string,
): Promise<TourEventsFormValues> {
  const csvRows: CsvColumns[] = csvToObj(text);
  const result: TourEventsFormValues = { tourEvents: [] };
  for (const row of csvRows) {
    result.tourEvents.push(await mapRowToTourEvent(row));
  }
  return result;
}

async function mapRowToTourEvent(
  row: CsvColumns,
): Promise<TourEventsFormValues['tourEvents'][number]> {
  return {
    ...defaultTourEventFormValues,
    date: mapDate(row['Date']),
    name: row['Nom'],
    position: await getGeocodePositionFromText(row['Lieu']),
    capacity: mapCapacity(row['Fréquentation']),
    type: mapTourEventType(row['Type']),
  };
}

function mapDate(date: string): string {
  const format = 'DD/MM/YYYY';
  const parsedDate = dayjs(date, format);
  if (!parsedDate.isValid()) {
    return '';
  }
  return parsedDate.toISOString();
}

function mapCapacity(capacity: string): number {
  return parseInt(capacity);
}

function mapTourEventType(type: string): TourEventType {
  switch (type) {
    case 'Salle':
      return 'venue';
    case 'Festival':
      return 'festival';
    default:
      return '';
  }
}
